const formatPostalCode = (postalCode, postalCodeSuffix) => {
  if (postalCode) {
    if (/\d{5}-\d{4}/.test(postalCode))
      return postalCode;
    if (/\d{9}/.test(postalCode))
      return `${postalCode.slice(0, 5)}-${postalCode.slice(5)}`;
    if (/\d{5}/.test(postalCode))
      return postalCodeSuffix && /\d{4}/.test(postalCodeSuffix) ? `${postalCode}-${postalCodeSuffix}` : postalCode;
    console.error(
      "[formatPostalCode] Postal code has invalid format",
      { postalCode, postalCodeSuffix }
    );
  }
};
export {
  formatPostalCode
};
//# sourceMappingURL=formatPostalCode.js.map
